import { useEffect } from "react";
import { useSingleSelectListState } from "@react-stately/list";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";

/**
 * Provides state management for a Tabs component. Tabs include a TabList which tracks
 * which tab is currently selected and displays the content associated with that Tab in a TabPanel.
 */
export function useTabListState(props) {
  let state = useSingleSelectListState(_babelRuntimeHelpersEsmExtends({}, props, {
    suppressTextValueWarning: true
  }));
  useEffect(() => {
    // Ensure a tab is always selected (in case no selected key was specified or if selected item was deleted from collection)
    let selectedKey = state.selectedKey;

    if (state.selectionManager.isEmpty || !state.collection.getItem(selectedKey)) {
      selectedKey = state.collection.getFirstKey();
      state.selectionManager.replaceSelection(selectedKey);
    }

    if (state.selectionManager.focusedKey == null) {
      state.selectionManager.setFocusedKey(selectedKey);
    }
  }, [state.selectionManager, state.selectedKey, state.collection]);
  return state;
}
//# sourceMappingURL=module.js.map
